<template>
  <el-dialog :visible.sync="show" :styles="styles" :class-name="className"
         :closable="closable"
         :width="styles.width"
         :custom-class="customClass"
         :mask-closable="maskClosable"
         @close="onVisibleChange" :modal-append-to-body="false">
    <div slot="title" class="modal-header">
      <span class="ml_10">{{ title }}</span>
      <div class="modal-header-fullscreen" v-if="showFullscreen">
        <i class="el-icon-rank" style="color: #999" v-if="!fullscreen" @click="fullscreen = !fullscreen"></i>
        <i class="el-icon-full-screen" style="color: #999" v-if="fullscreen" @click="fullscreen = !fullscreen"></i>
<!--        <Icon type="ios-expand" color="#999" size="17" v-if="!fullscreen" @click="fullscreen = !fullscreen"/>-->
<!--        <Icon type="ios-contract" color="#999" size="17" v-if="fullscreen" @click="fullscreen = !fullscreen"/>-->
      </div>
    </div>
    <slot></slot>
    <div slot="footer">
      <slot name="footer">
        <div class="modal-footer">
          <cus-button size="small" class="mr_2" @onClick="onCancel">取消</cus-button>
          <cus-button type="primary" size="small" @onClick="onOk">确认</cus-button>
        </div>
      </slot>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'cus-modal',
  data () {
    return {
      fullscreen: false,
      show: false,
    }
  },
  props: {
    title: {
      type: String,
      default: '添加'
    },
    width: {
      type: [String, Number],
      default: 700
    },
    showFullscreen: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: true,
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    customClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    styles () {
      let style = {}
      if (!this.fullscreen) {
        /*if (style.width.indexOf('px') !== -1 || style.width.indexOf('%') !== -1 || style.width.indexOf('vw') !== -1 || style.width.indexOf('vh') !== -1 || style.width.indexOf('rem') !== -1) {
          style.width = `${this.width}`;
        } else style.width = `${this.width}px`;*/
        style.width = `${this.width}px`
      } else {
        style.width = '100%'
        style.top = 0
      }
      return style
    },
    className () {
      if (this.fullscreen) {
        return 'fullscreen-modal'
      } else {
        return ''
      }
    }
  },
  methods: {
    onOk () {
      this.$emit('onOk')
    },
    onCancel () {
      this.show = false;
    },
    onVisibleChange (v) {
      this.$emit('on-visible-change', false)
    }
  }
}
</script>

<style lang="less">
.modal-header {
  display: flex;
  /*justify-content: center;*/
  align-items: center;
  position: relative;
  height: 20px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);

  &-fullscreen {
    position: absolute;
    right: 30px;
    cursor: pointer;

    i:hover {
      color: black !important;
    }
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/cuview-ui/components/cus-modal/cus-modal.vue